import api from "../../components/api"
import { CreateUpdateTenantLocationRequest, TenantLocation } from "./tenantLocation"

export const getTenantLocationsData = async (): Promise<TenantLocation[]> => {
  return (await api.get(`/web/tenant-locations`)).data
}

export const createTenantLocation = async (request: CreateUpdateTenantLocationRequest): Promise<void> => {
  return (await api.post(`/web/tenant-locations`, request)).data
}

export const updateTenantLocation = async (id: number, request: CreateUpdateTenantLocationRequest): Promise<void> => {
  return (await api.post(`/web/tenant-locations/${id}`, request)).data
}